const allygpoBaseUrl = "allygpo.com";
export const webAppEnvUrls = Object.freeze({
  prod: "app." + allygpoBaseUrl,
  stage: "app.stage." + allygpoBaseUrl,
  qa: "app.qa." + allygpoBaseUrl,
  dev: "app.dev." + allygpoBaseUrl,
  local: "localhost",
});
